( function( $ ) {
  if ( $( window ).width() > 1199 )
    new WOW().init();
})( jQuery );